import { useState, useCallback } from 'react';
import { api } from '../lib/api';

export function useImpersonation() {
  const [isImpersonating, setIsImpersonating] = useState(
    () => !!localStorage.getItem('adminAuthToken')
  );

  const impersonatingUser = isImpersonating
    ? JSON.parse(localStorage.getItem('impersonatingUser') || 'null')
    : null;

  const startImpersonating = useCallback(async (userId) => {
    const data = await api.auth.impersonate(userId);
    localStorage.setItem('adminAuthToken', localStorage.getItem('authToken'));
    localStorage.setItem('authToken', data.token);
    localStorage.setItem('impersonatingUser', JSON.stringify(data.user));
    setIsImpersonating(true);
    // Navigate to the appropriate dashboard for the impersonated user's role
    const userType = data.user?.user_type;
    window.location.href = userType === 'PARENT' ? '/family-dashboard' : '/dashboard';
  }, []);

  const stopImpersonating = useCallback(async () => {
    // Restore admin token first so the stop call is authenticated as admin
    const adminToken = localStorage.getItem('adminAuthToken');
    localStorage.setItem('authToken', adminToken);
    localStorage.removeItem('adminAuthToken');
    localStorage.removeItem('impersonatingUser');
    setIsImpersonating(false);

    try {
      await api.auth.stopImpersonating();
    } catch {
      // Best-effort — admin token is already restored regardless
    }

    window.location.href = '/settings';
  }, []);

  return { isImpersonating, impersonatingUser, startImpersonating, stopImpersonating };
}
